import React from 'react';
import styled from 'styled-components';

const InfoText = styled.p`
    color: red;
`;

export const SubmitSuccess = () => (
    <>
        <h3>Dziękujemy za oddanie głosu.</h3>
        <p>Na podany adres e-mail została wysłana wiadomość. Sprawdź swoją skrzynkę pocztową.</p>
        <InfoText>
            <strong>UWAGA.</strong> jeśli nie znajdziesz maila od nas, sprawdź folder SPAM.
        </InfoText>
    </>
);

export default SubmitSuccess;
